import "./App.css";
import PreventMobileLandscape from "./components/PreventMobileLandscape";
import Pages from "./routes/routes";
import emailjs from "@emailjs/browser";

function App() {
  emailjs.init({
    publicKey: "ps-p6gBHKx9uv4TtB",
    // Do not allow headless browsers
    blockHeadless: true,
    limitRate: {
      // Set the limit rate for the application
      id: "app",
      // Allow 1 request per 10s
      // throttle: 10000,
    },
  });

  return (
    <>
      {/* <PreventMobileLandscape /> */}
      <Pages />
    </>
  );
}

export default App;
